import React from 'react';
import { Circle } from 'src/components/';

const EmailFeedbackHeader = ({
  revieweeName,
  revieweeTitle,
  revieweeImage
}) => (
  <>
    <div className='h-32 -mb-18 bg-gradient-to-r from-indigo-500 via-purple-500 to-pink-500' />

    <div className='mb-6 flex flex-col items-center'>
      <Circle
        size='xxl'
        imageUrl={revieweeImage}
        classes='mb-4 user-setting-profile-image relative h-131 w-131'
      />
      <div className=''>
        <div className='text-2xl bold'>{revieweeName}</div>
        <div className='text-base text-gray-400 text-center'>
          {revieweeTitle}
        </div>
      </div>
    </div>
  </>
);

export default EmailFeedbackHeader;
